import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import { getAttendanceColor, getAttendanceHoverColor } from 'utils/helpers';

const Container = styled.div`
	background: ${(props) => props.background || '#eeeeee'};
	position: relative;

	:hover {
		background: ${(props) => props.hover || '#eeeeee'};
	}
`;

const AttendanceBlock = ({ data = { attendance: {}, program: {} }, goto }) => {
	const { attendance = { status: '', notes: '' }, program } = data;
	const { status } = attendance;
	const { programId, startTime, groupName } = program;

	return (
		<Container
			className="hand font-9 font-weight-bold w-100 p-2 border-top border-bottom"
			background={getAttendanceColor(status)}
			hover={getAttendanceHoverColor(status)}
			onClick={() => goto && goto(`groupDetails/${programId}`)}
			id={`block-${programId}`}
		>
			<div>
				{startTime} {groupName}
			</div>
		</Container>
	);
};

AttendanceBlock.propTypes = {
	data: PropTypes.shape({
		attendance: PropTypes.shape({
			status: PropTypes.string,
			notes: PropTypes.string,
		}),
		program: PropTypes.shape({
			programId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			startTime: PropTypes.string,
			groupName: PropTypes.string,
		}),
	}),
	goto: PropTypes.func,
};

export default AttendanceBlock;
